import { render, staticRenderFns } from "./GeneticSimilaritiesInfoModal.vue?vue&type=template&id=ff4b2954"
import script from "./GeneticSimilaritiesInfoModal.vue?vue&type=script&lang=js"
export * from "./GeneticSimilaritiesInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports